import { cnpjValidation } from './CnpjValidation';
import { cpfValidation } from './CpfValidation';

interface IReturn {
  valid: boolean;
  message: string;
}

const VALIDO: IReturn = { valid: true, message: '' };

// Ponto unico de validacao de documento: decide CPF ou CNPJ pela quantidade de
// digitos e devolve um veredito so, ja que cpfValidation e cnpjValidation tem
// formatos de retorno diferentes entre si.
export const documentValidation = (document: string): IReturn => {
  const digits = (document ?? '').replace(/\D/g, '');

  if (!digits) {
    return { valid: false, message: 'Informe o CPF ou o CNPJ.' };
  }

  if (digits.length === 11) {
    const { status, message } = cpfValidation({
      cpf: digits,
      emptyCpf: 'CPF inválido.',
      incorrectCpf: 'CPF inválido. Confira os números digitados.',
    });

    return status === '' ? VALIDO : { valid: false, message };
  }

  if (digits.length === 14) {
    const { status, message } = cnpjValidation({
      cnpj: digits,
      emptyCnpj: 'CNPJ inválido.',
      incorrectCnpj: 'CNPJ inválido. Confira os números digitados.',
    });

    return status === 'ok' ? VALIDO : { valid: false, message };
  }

  return {
    valid: false,
    message: 'Informe um CPF (11 dígitos) ou um CNPJ (14 dígitos).',
  };
};
